import { useEffect, useState } from "react";
import { Switch as HUSwitch } from "@headlessui/react";

export const Switch = ({ isEnabled, label, onChange, name }) => {
  const [enabled, setEnabled] = useState(!!isEnabled);

  useEffect(() => {
    setEnabled(isEnabled);
  }, [isEnabled]);

  const handleOnChange = (isToggled) => {
    setEnabled(isToggled);
    onChange(isToggled);
  };

  return (
    <div className="flex items-center">
      <HUSwitch name={name} checked={enabled} onChange={handleOnChange} className={`${enabled ? "bg-indigo-600" : "bg-gray-200"} relative inline-flex h-6 w-11 items-center rounded-full`}>
        <span className="sr-only">{label}</span>
        <span className={`${enabled ? "translate-x-6" : "translate-x-1"} inline-block h-4 w-4 transform rounded-full bg-white transition`} />
      </HUSwitch>

      {!!label && (
        <label className="ms-2 cursor-pointer text-sm font-semibold text-neutral-800" onClick={() => handleOnChange(!enabled)}>
          {label}
        </label>
      )}
    </div>
  );
};
